<template>
  <tr>
    <td>
      <div class="columns">
        <span class="dot tooltip is-tooltip-right" :class="statusColor(denunciation.status)"
              :data-tooltip="denunciationStatus[denunciation.status].label">
        </span>
        <a v-if="denunciation.duplicate_risk"
              :class="'tag is-small is-tooltip-right tooltip is-margin-left-xsmall ' + colors[denunciation.duplicate_risk - 1]"
              :data-tooltip="messages[denunciation.duplicate_risk - 1]"
              @click="showDuplicates">
          <i class="fal fa-exclamation-triangle"></i>
        </a>
      </div>
    </td>
    <td>
      <router-link :to="{name: 'LotVue', params: {id: denunciation.lot}}">
        {{denunciation.lot_ref}}
      </router-link>
    </td>
    <td v-if="showColumn('program_name')">
      {{denunciation.program_name}}
    </td>
    <td v-if="(!isExternal && isDistributeurMode) && showColumn('promoteur_name') ">
      {{denunciation.promoteur_name}}
    </td>
    <th v-if="(isAdmin || isSectorManager) && showColumn('company_name')">
       <router-link v-if="denunciation.company" :to="{name: 'CompanyVue', params: {id: denunciation.company}}">
        {{denunciation.company_name}}
      </router-link>
      <span v-else>
        NC
      </span>
    </th>
    <td v-if="(isAdmin || isSectorManager || isManager) && showColumn('seller_name')">
      <router-link :to="{name: 'UserVue', params: {id: denunciation.seller}}">
        {{denunciation.seller_name}}
      </router-link>
    </td>
    <td v-if="showColumn('buyer_name')">
      <router-link :to="{name: 'ContactVue', params: {id: denunciation.buyer}}">
        {{denunciation.buyer_name}}
      </router-link>
    </td>
    <td v-if="showColumn('created_on')">
      {{denunciation.created_on | prettyDatetime}}
    </td>
    <td v-if="isAdmin || isSectorManager">
      <display-button-list :buttons="buttonList" :data="denunciation"></display-button-list>
    </td>
  </tr>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { DefaultValues, DenunciationStatus } from '@/mixins'
  export default {
    name: 'DenunciationItem',
    data () {
      return {
        colors: ['is-optionne', 'is-warning', 'is-danger'],
        messages: ['Doublon Nom/Prénom', 'Doublon Nom/Prénom et Adresse', 'Doublon Email']
      }
    },
    props: {
      denunciation: {
        type: Object,
        required: true
      },
      buttonList: {
        type: Array
      },
      columnsSelected: {
        type: Array,
        default: () => []
      }
    },
    mixins: [DefaultValues, DenunciationStatus],
    computed: {
      ...mapGetters(['isAdmin', 'isManager', 'isSectorManager', 'isExternal', 'isDistributeurMode'])
    },
    methods: {
      showColumn (c) {
        return this.columnsSelected.includes(c)
      },
      showDuplicates () {
        this.$api.contactService.getOne(this.denunciation.buyer).then(r => {
          if (this.denunciation.duplicate_risk === 1) {
            this.$router.push({name: 'ContactList', query: {first_name: r.data.last_name}})
          }
          if (this.denunciation.duplicate_risk === 2) {
            this.$router.push({name: 'ContactList', query: {first_name: r.data.last_name}})
          }
          if (this.denunciation.duplicate_risk === 3) {
            this.$router.push({name: 'ContactList', query: {email: r.data.email}})
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/denunciation/DenunciationItem.vue